<template>
  <div class>
    <header-vue></header-vue>
    <div class="container-l2">
      <h1 class="h11">菜单管理</h1>
      <div class="clear">
        <div class="fl">
          <el-button @click="showAddCon()">
            <i class="fa fa-plus"></i> 添加菜单
          </el-button>          
          <el-cascader
            :options="typeList"
            expand-trigger="hover"
            @change="handleChange"
            :props="{ checkStrictly: true, label: 'name', value: 'id' }"
            ref="cascaderHandle"
            clearable>
          </el-cascader>
        </div>
      </div>
      <br />
      <el-table
        stripe
        border
        ref="multipleTable"
        :data="deviceList"
        tooltip-effect="dark"
        style="width: 100%"
      >
        <el-table-column type="index" width="50"></el-table-column>
        <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
        <el-table-column prop="link" label="链接地址" show-overflow-tooltip></el-table-column>
        <el-table-column prop="owername" label="所属菜单"></el-table-column>
        <el-table-column prop="type" label="类别" :formatter="formatMenuType"></el-table-column>
        <el-table-column prop="sort_id" label="排序"></el-table-column>
        <el-table-column prop="is_enable" label="是否可用"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="showModifyDia(scope.$index, scope.row)">修改</el-button>
            <el-button type="text" size="small" @click="showDeleteDia(scope.$index, scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <br />
      <div class="text-right">
        <el-pagination
          @current-change="handleCurrentChange"          
          :page-size="pagesize"
          layout="total, prev, pager, next"
          :total="totalNum"
        ></el-pagination>
      </div>
    </div>
    <!--添加修改菜单-->
    <el-dialog title="菜单菜单信息" :visible.sync="addFlag" width="500px">
      <el-form :model="manufac" ref="manufac">
        <el-form-item label="名称" :label-width="formLabelWidth">
          <el-input v-model="manufac.name" placeholder="请输入名称" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="链接地址" :label-width="formLabelWidth">
          <el-input v-model="manufac.link" placeholder="请输入链接地址" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="所属菜单" :label-width="formLabelWidth">

          <el-cascader
            :placeholder="manufac.owername"
            v-model="selectMenuOption"
            :options="typeList"
            expand-trigger="hover"
            @change="handleManuChange"
            :props="{ checkStrictly: true, label: 'name', value: 'id' }"
            ref="editCas"
            clearable>
          </el-cascader>
        </el-form-item>
        <el-form-item label="排序" :label-width="formLabelWidth">
          <el-input v-model="manufac.sort_id" type="number" placeholder="请输入排序序号" auto-complete="off"></el-input>
        </el-form-item>
        <el-form-item label="状态" :label-width="formLabelWidth">
          <el-radio-group v-model="manufac.is_enable">
            <el-radio label="Y">可用</el-radio>
            <el-radio label="N">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="ifAdd" label="类别" :label-width="formLabelWidth">
          <el-radio-group v-model="manufac.type">
            <el-radio :label="1">菜单</el-radio>
            <el-radio :label="2">按钮</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addFlag=false">取 消</el-button>
        <!-- 确定添加 -->
        <el-button type="primary" v-if="ifAdd" @click="confirmAddType()">确定</el-button>
        <!-- 确定修改 -->
        <el-button type="primary" v-if="!ifAdd" @click="modifyManu()">确定</el-button>
      </div>
    </el-dialog>
    <!--删除弹框-->
    <el-dialog title="删除提示框" :visible.sync="removeFlag" width="500px">
      <div class="userInfo">
        <h4>确认删除菜单菜单：{{manufac.name}} 吗？</h4>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="removeFlag = false">取消</el-button>
        <el-button type="primary" @click="deleteManu()">删 除</el-button>
      </div>
    </el-dialog>
    <loading v-if="showLoading"></loading>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$nextTick(function() {
      this.getAllMenu();
      this.getDeviceList();
    });
  },
  data() {
    return {
      deviceList: [],
      nowPage: 1,
      totalNum: 0,
      pagesize: 12,
      addFlag: false,
      formLabelWidth: "110px",
      showLoading: false,
      removeFlag: false,
      ifAdd: false,
      // 下拉选项
      typeList:[],
      
      // 搜索用菜单ID
      owerid: "-1",
      // 添加修改用菜单信息
      selectMenuOption: [],
      manufac: {
        name: "",
        link: "",
        owerid: "",
        sort_id: "",
        is_enable: "",
        type: ""
      },
    };
  },
  methods: {
   
    // 搜索用级联选择
    handleChange(value) {
      this.nowPage = 1;
      let num = value.length-1;
      this.$refs.cascaderHandle.dropDownVisible = false;
      this.owerid = value[num];
      this.getDeviceList();
    },
    // 添加修改菜单用级联选择
    handleManuChange(value){
      let num = value.length-1;
      this.$refs.editCas.dropDownVisible = false;
      this.manufac.owerid = value[num];
      this.getDeviceList();
    },
    getAllMenu() {
      let getAllMenuParams = {
        uid: this.getCookie("uid"),
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };
      this.sign2(getAllMenuParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Action/ablemenus",
          this.$qs.stringify(getAllMenuParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.typeList = this.formatTypeList(res.data.data);            
            
          } else if (res.data.code == 10008) {
            this.delCookie('username');
						this.$router.push('/login/');
						this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 获取所有菜单，然后去掉按钮
    formatTypeList(data){         
      if(data.length){
        data = data.filter(function(value){          
          if(value.children.length){
            value.children = value.children.filter(function(svalue){
              if(svalue.children.length){
                svalue.children = svalue.children.filter(function(ssvalue){
                  ssvalue.children = null;
                  return ssvalue.type == 1; 
                })                     
              }
              // 处理后的数组children是否为空
              if(svalue.children.length<1){
                svalue.children = null;
              }
              return svalue.type == 1;
            })
            return value.type == 1;
          }
          if(value.children.length<1){
            value.children = null;
          }
          return value.type == 1; 
        })       
      }
      return data;       
    },
    getDeviceList() {
      this.showLoading = true;
      let valiCodeParams = {
        uid: this.getCookie("uid"),
        owerid:this.owerid,
        page: this.nowPage,
        pagesize: this.pagesize,
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };

      this.sign2(valiCodeParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Action/menulist",
          this.$qs.stringify(valiCodeParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.deviceList = res.data.data.datalist || [];
            this.totalNum = res.data.data.totalNumber;
          } else if (res.data.code == 10008) {
            this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            //console.log(res.data.msg);
          }
        });
    },
    //			分页点击事件
    handleCurrentChange(val) {
      this.nowPage = val;
      this.getDeviceList();
    },
    showAddCon() {
      this.ifAdd = true;
      this.selectMenuOption = [];
      this.manufac = {
        name: "",
        link: "",
        owerid: "",
        sort_id: "",
        is_enable: "",
        type: ""
      };
      this.addFlag = true;
    },
    changeType(){
      this.nowPage = 1;
      this.getDeviceList();
    },
    //			添加
    confirmAddType() {
      let valiCodeParams = {
        uid: this.getCookie("uid"),
        name: this.manufac.name,
        owerid: this.manufac.owerid,
        link: this.manufac.link,
        is_enable: this.manufac.is_enable,
        sort_id: this.manufac.sort_id,
        type: this.manufac.type,
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };

      this.sign2(valiCodeParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Action/addmenu",
          this.$qs.stringify(valiCodeParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.addFlag = false;
            this.$message.success(res.data.msg);
            this.getDeviceList();
          } else if (res.data.code == 10008) {
            this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    showDeleteDia(index, row) {
      this.ifAdd = false;
      this.removeFlag = true;
      this.manufac = row;
    },
    deleteManu() {
      let valiCodeParams = {
        uid: this.getCookie("uid"),
        id: this.manufac.id,
        token: this.getCookie("token"),
        time: Date.parse(new Date()),
        terminalId: 4
      };

      this.sign2(valiCodeParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Action/delmenu",
          this.$qs.stringify(valiCodeParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          if (res.data.code == "200") {
            this.removeFlag = false;
            this.getDeviceList();
            this.$message.success(res.data.msg);
          } else if (res.data.code == 10008) {
            this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    showModifyDia(index, row) {      
      this.ifAdd = false;
      this.selectMenuOption = [];
      this.manufac = row;
      this.addFlag = true;
    },
    modifyManu() {      
      let valiCodeParams = {
        uid: this.getCookie("uid"),
        id: this.manufac.id,
        name: this.manufac.name,
        link: this.manufac.link,
        owerid: this.manufac.owerid,
        sort_id: this.manufac.sort_id,
        is_enable: this.manufac.is_enable,
        token: this.getCookie("token"),
        time: Date.parse(new Date())
      };

      this.sign2(valiCodeParams);
      this.$ajax
        .post(
          this.$store.state.domain2 + "/admin/Action/updatemenu",
          this.$qs.stringify(valiCodeParams),
          {
            emulateJSON: true
          }
        )
        .then(res => {
          this.showLoading = false;
          if (res.data.code == "200") {
            this.$message.success(res.data.msg);
            this.addFlag = false;
            this.getDeviceList();
          } else if (res.data.code == 10008) {
            this.delCookie('username');
							this.$router.push('/login/');
							this.$store.commit('updateUserInfo', this.$store.state.originalUserInfo); 
          } else {
            //console.log(res.data.msg);
            this.$message.error(res.data.msg);
          }
        });
    }
  }
};
</script>

<style>
.search-box2 {
  margin-top: -69px;
}
</style>


// WEBPACK FOOTER //
// src/components/rightPanel/menuManage.vue